<template>
    <div id="quality-details">
        <div class="title">品控分详细</div>
        <div class="main mr40">
            <div class="content-good">
                <p class="good-title"> {{ this.title }} </p>
                <p class="good-size">
                    {{ this.skuName }}
                </p>
            </div>
            <div class="chart-good">
                <el-row>
                    <el-col :span="4">
                        <ul>
                            <li>价格分：{{ this.pricee }}</li>
                            <li>评价分：{{ this.salesquantitye }}</li>
                            <li>品质分：{{ this.qualitye }}</li>
                            <li>物流分：{{ this.deliverye }}</li>
                            <li>服务分：{{ this.servicee }}</li>
                            <li>保障分：{{ this.guaranteee }}</li>
                        </ul>
                    </el-col>
                    <el-col :span="12">
                        <div class="echarts" ref="echarts" style="width: 100%; height: 310px;"></div>
                    </el-col>
                </el-row>
            </div>
            <div class="back-on-page">
                <el-button style="padding: 12px 24px" @click="backonPage">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import { getGoodsCreditDetail } from '@/api/qualityControl'
export default {
    name: 'qualityDetails',
    data () {
        return {
            chart: null,
            loading: false,
            goodDetails: {},
            title: '',
            skuName: ''
        }
    },
    computed: {
        // 保障分
        guaranteee () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.guaranteeevalue
            } else {
                return 0
            }
        },
        // 服务分
        servicee () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.serviceevalue
            } else {
                return 0
            }
        },
        // 品质分
        qualitye () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.qualityevalue
            } else {
                return 0
            }
        },
        // 评价分
        salesquantitye () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.salesquantityevalue
            } else {
                return 0
            }
        },
        // 物流分
        deliverye () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.deliveryevalue
            } else {
                return 0
            }
        },
        // 价格分
        pricee () {
            let { evaluationresult } = this.goodDetails;
            if (evaluationresult) {
                return evaluationresult.priceevalue
            } else {
                return 0
            }
        },
    },
    methods: {
        createChart () {
            let option = {
                // title: {
                //     text: '品控详情图'
                // },
                // legend: {
                //     data: ['保障', '品质', '价格', '服务', '评价', '物流']
                // },
                // 提示框组件
                tooltip: {
                    trigger: 'item',
                    confine: true
                },
                radar: {
                    indicator: [
                        { name: '价格分', max: 999 },
                        { name: '保障分', max: 999 },
                        { name: '服务分', max: 999 },
                        { name: '物流分', max: 999 },
                        { name: '品质分', max: 999 },
                        { name: '评价分', max: 999 },
                    ],
                    shape: 'circle',
                    axisName: {
                        show: true,
                        // color: '#f00',
                        fontSize: 18
                    },
                    // splitArea: {
                    //     areaStyle: {
                    //         color: ['#77EADF', '#26C3BE', '#64AFE9', '#428BD4'],
                    //         shadowColor: 'rgba(0, 0, 0, .5)',
                    //         shadowBlur: 5
                    //     }
                    // },
                    // 旋转角度
                    // startAngle: 90,
                    // 层数
                    // splitNumber: 4,
                    // 内角连线
                    // axisLine: {
                    //     lineStyle: {
                    //         color: 'rgba(255, 0, 0, 1)'
                    //     }
                    // },
                    // 线圈颜色
                    // splitLine: {
                    //     lineStyle: {
                    //         color: 'rgba(0, 0, 0, 1)'
                    //     }
                    // }
                },
                series: [
                    {
                        name: this.title.length > 30 ? this.title.slice(0, 30) + '...' : this.title,
                        type: 'radar',
                        label: {
                            show: true,
                            position: 'top',
                            distance: -15
                        },
                        emphasis: {
                            focus: 'series',
                            areaStyle: {
                                color: 'rgba(0,250,0,0.3)'
                            }
                        },
                        data: [
                            {
                                value: [this.pricee, this.guaranteee, this.servicee, this.deliverye, this.qualitye, this.salesquantitye]
                                // name: '保障'
                            }
                        ]
                    }
                ]
            };
            this.chart.setOption(option);
        },
        backonPage () {
            let page = this.$route.query.page;
            let size = this.$route.query.size;
            this.$router.push({ path: '/home/qualityControl', query: { page, size } });
        },
        initData () {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            getGoodsCreditDetail({ goodsids: this.$route.query.goodsids})
                .then(res => {
                    if (res.status == 200) {
                        this.goodDetails = res.data.data;
                        if (!this.chart) {
                            this.chart = echarts.init(this.$refs.echarts);
                            this.createChart();
                        }
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                })
                .finally( _ => {
                    loading.close();
                })
        }
    },
    mounted () {},
    created () {
        this.title = this.$route.query.title; 
        this.skuName = this.$route.query.skuName;
        this.initData();
    },
    beforeDestroy () {
        this.chart.dispose();
    }
}
</script>

<style lang='scss' scoped>
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 18px;
        color: #333;
        width: 100%;
        padding: 15px 32px;
    }

    .main {
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 36px;
        padding-bottom: 70px;
        min-width: 1200px;
        span {
            margin-right: 10px;
            ::v-deep .el-input {
                width: 300px;
                display: inline-block;
            }
        }
        .el-cascader {
            ::v-deep .el-input {
                width: 320px !important;
            }
        }
    }

    .table {
        position: relative;
        .el-button {
            position: absolute;
            left: 300px;
            top: 0px;
            z-index: 1;
        }
    }

    .main {
        .content-good {
            .good-title {
                line-height: 30px;
                font-size: 18px;
                font-weight: 600;
            }
            .good-size {
                line-height: 30px;
                text-indent: 12px;
                margin-top: 12px;
                span:not(:first-child) {
                    margin-left: 24px;
                }
            }
        }
        .chart-good {
            margin-top: 12px;
            ul {
                list-style-type: none;
                li {
                    font-size: 18px;
                    line-height: 48px;
                    text-indent: 24px;
                }
            }
        }
        .back-on-page {
            display: flex;
            width: 100%;
            justify-content: center;
            margin-top: 24px;
        }
        .el-form {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .mr40 {
        .el-form-item {
            margin-right: 40px;
        }
        .mr20 {
            margin-right: 10px;
        }
    }

    ::v-deep .el-range-separator {
        padding: 0px;
    }
</style>